import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueMapValues',
  pure: false
})
export class UniquePipe implements PipeTransform {
  transform(array: any, key: string): any[] {
    if(!array){
      return [];
    }
    const arrayUniqueByKey = array.map(item => {
      return {
        key: item.key,
        value: [...new Map(item.value.map(item => [item[key], item])).values()],
      }
    })
    return arrayUniqueByKey;
  }
}
